import UserType from './UserType'

const userReducer = (state, action) => {
  switch (action.type) {
    case UserType.GET_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false,
      }
    case UserType.GET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
      }
    case UserType.CREATE_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
      }
    case UserType.UPDATE_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
      }
    case UserType.DELETE_USER:
      return {
        ...state,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default userReducer
